import React, { useState } from "react";
import { EyeIcon } from "../../../../assets/EyeIcon";
import { ExampleModal } from "./CarouselExampleModal";
import TextExample from "../../../../assets/TextExample.png";

interface SlideTextSectionProps {
    primaryText: string;
    primaryColor: string;
    secondaryText: string;
    secondaryColor: string;
    isRestricted: boolean;
    onFieldChange: (id: string, value: string) => void;
}

export const CarouselSlideEditorTextSection: React.FC<SlideTextSectionProps> = ({
    primaryText,
    primaryColor,
    secondaryText,
    secondaryColor,
    isRestricted,
    onFieldChange,
}) => {
    const [showExample, setShowExample] = useState(false);

    return (
        <section className="editSection editSection--text">
            <div className="editSection__head">
                <div className="title">Text</div>
                <button type="button" className="seeExample" onClick={() => setShowExample(true)}>
                    <span className="eyeIcon" />See Example <EyeIcon />
                </button>
            </div>

            <div className="textGrid">
                <div className="col">
                    <p>Primary Text <span>Recommended (Max 40 characters)</span></p>
                    <div className="color-input-wrapper">
                        <input
                            id="h2.text"
                            type="text"
                            className="input-round form-control"
                            placeholder="Example: WINTER SALE"
                            onChange={(e) => onFieldChange("h2.text", e.target.value)}
                            value={primaryText}
                        />
                        <div className="color">
                            <p>Text<br />Color</p>
                            <input
                                id="h2.color"
                                type="color"
                                value={primaryColor}
                                onChange={(e) => onFieldChange("h2.color", e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className={`col ${isRestricted ? "disabled" : ""}`}>
                    <p>Secondary Text <span>Recommended (Max 40 characters)</span></p>
                    <div className="color-input-wrapper">
                        <input
                            id="p.text"
                            type="text"
                            className="input-round form-control"
                            placeholder="Example: All products up to 50% off"
                            onChange={(e) => onFieldChange("p.text", e.target.value)}
                            value={secondaryText}
                            disabled={isRestricted}
                        />
                        <div className="color">
                            <p>Text<br />Color</p>
                            <input
                                id="p.color"
                                type="color"
                                value={secondaryColor}
                                onChange={(e) => onFieldChange("p.color", e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <ExampleModal
                title="Text example"
                imageSrc={TextExample}
                open={showExample}
                onClose={() => setShowExample(false)}
            />
        </section>
    );
};